module.exports = __webpack_public_path__ + "c56ce74bfbdecaf49beeb92edb02a363.jpg";